const FASTLY_URL = process.env.FASTLY_URL || ""

export default async function fetchGeoIp() {
  return fetch(`${FASTLY_URL}/country-code`)
    .then((response) => response.json())
    .catch((err) => {
      console.warn(err)
      return {
        country_code: "",
        region: "",
      }
    })
}

export const fetchGeoIpWithRedirect = async () => {
  const geoIp = await fetchGeoIp()

  if (geoIp.country_code === "banned") {
    window.location = document.location.origin + "/unavailable"
  }

  return geoIp
}
